import { CloseIcon } from '../ui/icons';

interface EventNameSearchProps {
  value: string;
  onChange: (next: string) => void;
}

export const EventNameSearch = ({ value, onChange }: EventNameSearchProps) => (
  <div className="relative">
    <input
      type="search"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder="Search events or wineries…"
      aria-label="Search events"
      className="w-full rounded-md border border-gray-300 bg-gray-50 px-3 py-2 pr-10 text-sm font-sans text-gray-900 placeholder:text-gray-500 focus:border-primary-700 focus:outline-none focus:ring-1 focus:ring-primary-700"
    />
    {value && (
      <button
        type="button"
        onClick={() => onChange('')}
        aria-label="Clear event search"
        className="absolute right-1 top-1/2 -translate-y-1/2 flex items-center justify-center min-h-[44px] min-w-[44px] text-gray-500 hover:text-gray-700"
      >
        <CloseIcon className="h-4 w-4" />
      </button>
    )}
  </div>
);
